module.exports = __webpack_public_path__ + "static/media/tyre-yellow-three5.6628e79a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/tyre-yellow-three5.png
// module id = 362
// module chunks = 0